<div class="movie-preview" [ngStyle]="{'background-image': 'url(' + manga.cover + ')'}">
    <div class="overlay"></div>
  
    <div class="content">
      @if (!isMobileView) {
        <div class="left-panel">
            @for (episode of episodes; track episode) {
              <app-manga-episode [episode]="episode"></app-manga-episode>
            }
        </div>
      }
  
      <div class="right-panel">
        <div class="cover-container">
          <img class="cover" [src]="manga.cover" alt="Movie Cover" />
        </div>
      
        <div class="manga-card-container">
          <app-manga-info [manga]="manga" [author]="author"></app-manga-info>
        </div>
        
        @if (isMobileView) {
          <div class="episode-container">
            @for (episode of episodes; track episode) {
              <app-manga-episode [episode]="episode"></app-manga-episode>
            }
          </div>
        }
    </div>
  </div>